import request from './request'
import * as http from '@/libs/http'

/**
 * 店舗のサービスを取得する
 *
 * @param {Number} shopid 店舗ID
 * @returns {Response} レスポンスデータ
 */
export function getShopServices (shopid) {
  return request.get(`/shops/${shopid}/services`, {
    validateStatus: (status) => [
      http.OK
    ].includes(status)
  })
}
